import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";

@Module
export class AppModule extends VuexModule {
    private _openCredits: number = 0;

    get openCredits() {
        return this._openCredits;
    }

    @Mutation
    private _openCreditsMut() {
        this._openCredits++;
    }

    @Action
    openCreditsAction() {
        this._openCreditsMut();
    }
}